import { render, staticRenderFns, recyclableRender, components } from "./virtual-account.vue?vue&type=template&id=55a29c78&scoped=true&"
var renderjs
import script from "./virtual-account.vue?vue&type=script&lang=js&"
export * from "./virtual-account.vue?vue&type=script&lang=js&"
import style0 from "./virtual-account.vue?vue&type=style&index=0&lang=css&"
import style1 from "./virtual-account.vue?vue&type=style&index=1&id=55a29c78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../办公/HBuilderX.3.8.12.20230817/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a29c78",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pagesA/pages/virtual-account/virtual-account.vue"
export default component.exports